import type { AxiosInstance } from 'axios'
import { useGameContest } from '@/store'

import type { ClientApi, ParticipantParams } from '../../api'

export default ($axios: AxiosInstance): ClientApi['contestGamesParticipants'] => ({
  create(id: string, storeSlug: string, params: ParticipantParams) {
    const store = useGameContest()
    return $axios.post(
      `/public/contest-games/${id}/stores/${storeSlug}/participants?locale=${store.locale}`,
      {
        ...params,
      },
    )
  },
})
